"use client";

import { useLingui } from "@lingui/react/macro";
import { Text } from "@offstreetparking/design-system/typography";
type SelectionSummaryProps = {
	label: string;
	value: string;
	subtitle?: string;
	onReset?: () => void;
};
export const SelectionSummary = ({ label, value, subtitle, onReset }: SelectionSummaryProps) => {
	const { t } = useLingui();
	return (
		<div className="flex items-center justify-between border-neutral-faded border-b px-8 py-3">
			<div className="flex gap-2">
				<Text size="sm" intent="muted">
					{label}:
				</Text>
				<div className="flex flex-col">
					<Text size="sm" weight="bold">
						{value}
					</Text>
					{subtitle && (
						<Text size="sm" intent="muted">
							{subtitle}
						</Text>
					)}
				</div>
			</div>
			{onReset && (
				<button type="button" className="font-medium text-primary text-sm hover:underline" onClick={onReset}>
					{t`Change`}
				</button>
			)}
		</div>
	);
};
